exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")();
// imports


// module
exports.push([module.id, ".workflow[data-v-7479abca]{display:flex;align-items:center;justify-content:space-between}.card[data-v-7479abca]{padding:10px;border:2px solid #000;min-width:100px;overflow:auto;word-wrap:break-word}.arrow[data-v-7479abca],.delay[data-v-7479abca]{width:42px;height:auto;display:flex;align-items:center;justify-content:center;position:relative;flex-direction:column}.arrow[data-v-7479abca]:after{content:\"\";position:absolute;left:10%;top:50%;transform:translateY(-50%);border-style:solid;border-width:30px 0 30px 30px;border-color:transparent transparent transparent #000}.delay[data-v-7479abca]{background-color:#ff0}", ""]);

// exports



//////////////////
// WEBPACK FOOTER
// ./~/css-loader!./~/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-7479abca","scoped":true,"hasInlineConfig":false}!./~/vue-loader/lib/selector.js?type=styles&index=0!./src/component/dashboard/billingInvCard.vue
// module id = 1706
// module chunks = 0